// Detailed, bilingual content for each of the 13 specific-feature pages.
// Chart values are ILLUSTRATIVE / representative (MOCK) to visualise the effect.
// Keyed by slug (see FEATURE_SLUGS in site.js).

export const featureDetails = {
  'pore-size': {
    chart: {
      unit: { de: 'Relative Wasserdurchl\u00e4ssigkeit \u2013 niedriger ist besser', en: 'Relative water permeability \u2013 lower is better' },
      bars: [
        { key: 'ref', value: 100, display: '100', highlight: false },
        { key: 'mk', value: 55, display: '~55', highlight: true },
      ],
    },
    de: {
      intro: ['Metakaolin kann das Porengef\u00fcge verfeinern: gr\u00f6\u00dfere Kapillarporen k\u00f6nnen durch zus\u00e4tzlich gebildete Hydratphasen unterbrochen und verkleinert werden. Dies kann zu einer dichteren Matrix mit reduzierter Durchl\u00e4ssigkeit beitragen.', 'Eine geringere Durchl\u00e4ssigkeit gilt als wesentliche Grundlage vieler Dauerhaftigkeitseigenschaften \u2013 von der Chlorid- bis zur Frost-Tau-Best\u00e4ndigkeit.'],
      example: { title: 'Praxisbeispiel', text: 'In einem gepr\u00fcften wasserdichten Kellerbeton konnte ein Austausch von rund 12\u00a0% des Zements durch Metakaolin die kapillare Wasseraufnahme verringern. Die \u00dcbertragbarkeit ist rezepturabh\u00e4ngig.' },
    },
    en: {
      intro: ['Metakaolin can refine the pore structure: larger capillary pores can be interrupted and reduced by additional hydrate phases. This can contribute to a denser matrix with reduced permeability.', 'Lower permeability is regarded as a key basis for many durability properties \u2013 from chloride to freeze\u2013thaw resistance.'],
      example: { title: 'Practical example', text: 'In a tested water-tight basement concrete, replacing about 12% of the cement with metakaolin reduced capillary water uptake. Transferability depends on the mix design.' },
    },
  },
  durability: {
    chart: {
      unit: { de: 'Relativer Dauerhaftigkeitsindex \u2013 h\u00f6her ist besser', en: 'Relative durability index \u2013 higher is better' },
      bars: [
        { key: 'ref', value: 100, display: '100', highlight: false },
        { key: 'mk', value: 165, display: '~165', highlight: true },
      ],
    },
    de: {
      intro: ['Ein dichteres Gef\u00fcge und der Verbrauch von freiem Kalk k\u00f6nnen die Widerstandsf\u00e4higkeit gegen verschiedene chemische und physikalische Angriffsmechanismen erh\u00f6hen.', 'Bauteile mit Metakaolin k\u00f6nnen \u2013 abh\u00e4ngig von Rezeptur und Expositionsbedingungen \u2013 eine l\u00e4ngere rechnerische Nutzungsdauer erreichen.'],
      example: { title: 'Praxisbeispiel', text: 'Br\u00fcckenkappen in Streusalzumgebung zeigten mit Metakaolin in einem gepr\u00fcften Fall geringere Sch\u00e4digung als die Referenzmischung; die \u00dcbertragbarkeit ist projektbezogen zu pr\u00fcfen.' },
    },
    en: {
      intro: ['Thanks to a denser microstructure and the consumption of free lime, resistance to various chemical and physical attack mechanisms can increase.', 'Elements containing metakaolin can \u2013 depending on mix design and exposure conditions \u2013 achieve a longer calculated service life.'],
      example: { title: 'Practical example', text: 'In one tested case, bridge kerbs in a de-icing-salt environment showed less deterioration with metakaolin than the reference mix; transferability must be assessed per project.' },
    },
  },
  'adhesion-strength': {
    chart: {
      unit: { de: 'Haftzugfestigkeit in N/mm\u00b2 \u2013 h\u00f6her ist besser', en: 'Bond strength in N/mm\u00b2 \u2013 higher is better' },
      bars: [
        { key: 'ref', value: 0.8, display: '0.8', highlight: false },
        { key: 'mk', value: 1.4, display: '~1.4', highlight: true },
      ],
    },
    de: {
      intro: ['Metakaolin verbessert die Haftung von Putzen, Klebern und Reparaturm\u00f6rteln am Untergrund durch feinere Kontaktzonen und ein dichteres Gef\u00fcge.', 'Das erh\u00f6ht die Verbundsicherheit gerade bei d\u00fcnnen Schichten und anspruchsvollen Untergr\u00fcnden.'],
      example: { title: 'Praxisbeispiel', text: 'Ein Fliesenkleber mit Metakaolin erreichte h\u00f6here Haftzugwerte und ein sichereres Verhalten auf glatten Betonuntergr\u00fcnden.' },
    },
    en: {
      intro: ['Metakaolin improves the bond of renders, adhesives and repair mortars to the substrate through finer contact zones and a denser matrix.', 'This increases bond reliability, especially for thin layers and demanding substrates.'],
      example: { title: 'Practical example', text: 'A tile adhesive with metakaolin achieved higher bond strengths and safer behaviour on smooth concrete substrates.' },
    },
  },
  'water-retention': {
    chart: {
      unit: { de: 'Wasserr\u00fcckhalteverm\u00f6gen in % \u2013 h\u00f6her ist besser', en: 'Water retention in % \u2013 higher is better' },
      bars: [
        { key: 'ref', value: 88, display: '88 %', highlight: false },
        { key: 'mk', value: 97, display: '~97 %', highlight: true },
      ],
    },
    de: {
      intro: ['Die feine Partikelgr\u00f6\u00dfe und hohe Oberfl\u00e4che von Metakaolin verbessern Verarbeitbarkeit und Wasserr\u00fcckhaltung des Frischm\u00f6rtels.', 'Auf saugenden Untergr\u00fcnden wird ein zu schnelles Austrocknen verhindert \u2013 die Hydratation l\u00e4uft vollst\u00e4ndiger ab.'],
      example: { title: 'Praxisbeispiel', text: 'Ein Kalk-Zement-Putz mit Metakaolin lie\u00df sich auf stark saugendem Ziegel gleichm\u00e4\u00dfiger auftragen und neigte weniger zu Trockenrissen.' },
    },
    en: {
      intro: ['The fine particle size and high surface area of metakaolin improve the workability and water retention of fresh mortar.', 'On absorbent substrates, premature dry-out is prevented \u2013 hydration proceeds more completely.'],
      example: { title: 'Practical example', text: 'A lime-cement render with metakaolin applied more evenly on highly absorbent brick and was less prone to drying cracks.' },
    },
  },
  'asr-reduction': {
    chart: {
      unit: { de: 'Dehnung durch AKR in % \u2013 niedriger ist besser', en: 'ASR expansion in % \u2013 lower is better' },
      bars: [
        { key: 'ref', value: 0.20, display: '0.20 %', highlight: false },
        { key: 'mk', value: 0.04, display: '~0.04 %', highlight: true },
      ],
    },
    de: {
      intro: ['Metakaolin kann Alkalien binden und die Alkalit\u00e4t der Porenl\u00f6sung senken. Dadurch kann das Risiko der sch\u00e4digenden Alkali-Kiesel-Reaktion (AKR) verringert werden; dies ist \u00fcber geeignete Pr\u00fcfverfahren nachzuweisen.', 'Bei geeigneter Zusammensetzung kann dies den Einsatz potenziell reaktiver Gesteinsk\u00f6rnungen unterst\u00fctzen.'],
      example: { title: 'Praxisbeispiel', text: 'Mit potenziell AKR-empfindlichem Zuschlag hergestellter Beton zeigte mit Metakaolin im Dehnungsversuch eine deutlich geringere Expansion; die Eignung ist im Einzelfall nachzuweisen.' },
    },
    en: {
      intro: ['Metakaolin can bind alkalis and lower the alkalinity of the pore solution, which can reduce the risk of the damaging alkali\u2013silica reaction (ASR); this must be demonstrated by appropriate test methods.', 'With a suitable composition, this can support the use of potentially reactive aggregates.'],
      example: { title: 'Practical example', text: 'Concrete made with potentially ASR-sensitive aggregate showed clearly lower expansion in the mortar-bar test when metakaolin was used; suitability must be demonstrated case by case.' },
    },
  },
  'sulphate-resistance': {
    chart: {
      unit: { de: 'Dehnung nach Sulfatangriff in % \u2013 niedriger ist besser', en: 'Expansion after sulphate attack in % \u2013 lower is better' },
      bars: [
        { key: 'ref', value: 0.30, display: '0.30 %', highlight: false },
        { key: 'mk', value: 0.05, display: '~0.05 %', highlight: true },
      ],
    },
    de: {
      intro: ['Durch den Verbrauch von freiem Kalk und die Verfeinerung des Gef\u00fcges kann Metakaolin in geeigneten Bindemittelsystemen das Sulfatwiderstandsverhalten verbessern. Die Bewertung muss bezogen auf Bindemittel, Sulfatmedium und Expositionsbedingungen erfolgen.', 'Die Wirkung ist nicht auf jedes Sulfatmedium oder jede Bindemittelrezeptur \u00fcbertragbar. Insbesondere bei magnesiumsulfathaltiger Beanspruchung sind geeignete projektbezogene Pr\u00fcfungen erforderlich.'],
      example: { title: 'Praxisbeispiel', text: 'Fundamente in sulfathaltigem Boden k\u00f6nnen von Metakaolin profitieren; die Eignung ist f\u00fcr das jeweilige Sulfatmedium nachzuweisen.' },
    },
    en: {
      intro: ['By consuming free lime and refining the microstructure, metakaolin can improve sulphate-resistance behaviour in suitable binder systems. The assessment must relate to the binder, the sulphate medium and the exposure conditions.', 'The effect is not transferable to every sulphate medium or binder mix. In particular, magnesium-sulphate exposure requires appropriate project-specific testing.'],
      example: { title: 'Practical example', text: 'Foundations in sulphate-bearing soil can benefit from metakaolin; suitability must be demonstrated for the specific sulphate medium.' },
    },
  },
  efflorescence: {
    chart: {
      unit: { de: 'Ausbl\u00fchungsindex \u2013 niedriger ist besser', en: 'Efflorescence index \u2013 lower is better' },
      bars: [
        { key: 'ref', value: 100, display: '100', highlight: false },
        { key: 'mk', value: 15, display: '~15', highlight: true },
      ],
    },
    de: {
      intro: ['Ausbl\u00fchungen entstehen, wenn freier Kalk an die Oberfl\u00e4che wandert und mit CO\u2082 reagiert. Metakaolin kann diesen Kalk binden und damit das Risiko von Ausbl\u00fchungen in geeigneten Systemen reduzieren.', 'Besonders bei Sicht- und Farbbeton kann dies zu einer gleichm\u00e4\u00dfigeren Oberfl\u00e4che beitragen.'],
      example: { title: 'Praxisbeispiel', text: 'Farbige Pflastersteine mit Metakaolin blieben nach Bewitterung weitgehend frei von den typischen wei\u00dfen Kalkschleiern; die Wirkung ist rezepturabh\u00e4ngig.' },
    },
    en: {
      intro: ['Efflorescence occurs when free lime migrates to the surface and reacts with CO\u2082. Metakaolin can bind this lime and thereby reduce the risk of efflorescence in suitable systems.', 'Especially for visible and coloured concrete, this can contribute to a more uniform surface.'],
      example: { title: 'Practical example', text: 'Coloured paving stones with metakaolin remained largely free of the typical white lime bloom after weathering; the effect depends on the mix design.' },
    },
  },
  'chloride-migration': {
    chart: {
      unit: { de: 'Relativer Chloridmigrationskoeffizient \u2013 niedriger ist besser', en: 'Relative chloride migration coefficient \u2013 lower is better' },
      bars: [
        { key: 'ref', value: 100, display: '100', highlight: false },
        { key: 'mk', value: 35, display: '~35', highlight: true },
      ],
    },
    de: {
      intro: ['Ein dichteres Porengef\u00fcge und die Alkalibindung k\u00f6nnen das Eindringen von Chloriden reduzieren, sofern Rezeptur und Nachbehandlung darauf abgestimmt sind \u2013 ein wichtiger Faktor f\u00fcr den Korrosionsschutz der Bewehrung.', 'Relevant f\u00fcr Meeresbauwerke und Bauteile mit Streusalzbelastung \u2013 nach projektbezogener Pr\u00fcfung.'],
      example: { title: 'Praxisbeispiel', text: 'Kaimauern in Meerwasserumgebung erreichten mit Metakaolin in gepr\u00fcften Rezepturen einen geringeren Chloridmigrationskoeffizienten; die \u00dcbertragbarkeit ist zu pr\u00fcfen.' },
    },
    en: {
      intro: ['The denser pore structure and alkali binding can reduce chloride ingress, provided the mix design and curing are tailored accordingly \u2013 an important factor for protecting the reinforcement from corrosion.', 'Relevant for marine structures and elements exposed to de-icing salts \u2013 subject to project-specific testing.'],
      example: { title: 'Practical example', text: 'In tested mixes, quay walls in a seawater environment achieved a lower chloride migration coefficient with metakaolin; transferability must be verified.' },
    },
  },
  'lighter-colour': {
    chart: {
      unit: { de: 'Wei\u00dfgrad L* \u2013 h\u00f6her ist heller', en: 'Whiteness L* \u2013 higher is brighter' },
      bars: [
        { key: 'ref', value: 70, display: 'L* 70', highlight: false },
        { key: 'mk', value: 88, display: 'L* ~88', highlight: true },
      ],
    },
    image: {
      caption: { de: 'Heller Sichtbeton: gleichm\u00e4\u00dfige, aufgehellte Oberfl\u00e4chen betonen die architektonische Wirkung.', en: 'Light fair-faced concrete: uniform, brightened surfaces emphasise the architectural effect.' },
    },
    de: {
      intro: ['Hochwertiges, wei\u00dfes Metakaolin hellt Beton und M\u00f6rtel auf und erm\u00f6glicht brillante, gleichm\u00e4\u00dfige Oberfl\u00e4chen.', 'Bei farbigem Beton kommen Pigmente reiner und intensiver zur Geltung.'],
      example: { title: 'Praxisbeispiel', text: 'Architektonische Sichtbetonelemente erhielten mit wei\u00dfem Metakaolin eine besonders helle, edle Anmutung.' },
    },
    en: {
      intro: ['High-grade white metakaolin brightens concrete and mortar, enabling brilliant, uniform surfaces.', 'For coloured concrete, pigments appear purer and more intense.'],
      example: { title: 'Practical example', text: 'Architectural fair-faced concrete elements gained a particularly bright, refined appearance with white metakaolin.' },
    },
  },
  'freeze-thaw': {
    chart: {
      unit: { de: 'Abwitterung nach 56 Frost-Tau-Zyklen \u2013 niedriger ist besser', en: 'Scaling after 56 freeze\u2013thaw cycles \u2013 lower is better' },
      bars: [
        { key: 'ref', value: 100, display: '100', highlight: false },
        { key: 'mk', value: 30, display: '~30', highlight: true },
      ],
    },
    de: {
      intro: ['Das dichtere Gef\u00fcge reduziert die Wasseraufnahme und damit die Sch\u00e4digung durch Frost-Tau-Wechsel und Taumittel.', 'Oberfl\u00e4chen bleiben l\u00e4nger geschlossen und tragf\u00e4hig.'],
      example: { title: 'Praxisbeispiel', text: 'Vorplatzbeton mit Metakaolin zeigte nach mehreren Wintern deutlich weniger Abplatzungen an der Oberfl\u00e4che.' },
    },
    en: {
      intro: ['The denser matrix reduces water uptake and therefore damage from freeze\u2013thaw cycles and de-icing agents.', 'Surfaces stay closed and load-bearing for longer.'],
      example: { title: 'Practical example', text: 'Forecourt concrete with metakaolin showed clearly less surface scaling after several winters.' },
    },
  },
  'acid-resistance': {
    chart: {
      unit: { de: 'Massenverlust bei S\u00e4ureangriff \u2013 niedriger ist besser', en: 'Mass loss under acid attack \u2013 lower is better' },
      bars: [
        { key: 'ref', value: 100, display: '100', highlight: false },
        { key: 'mk', value: 45, display: '~45', highlight: true },
      ],
    },
    de: {
      intro: ['Durch den reduzierten Anteil an l\u00f6slichem Kalkhydrat steigt die Best\u00e4ndigkeit gegen leichte S\u00e4ureeinwirkung.', 'Relevant in Industrie, Landwirtschaft und Abwasseranlagen.'],
      example: { title: 'Praxisbeispiel', text: 'Beton in einer Biogasanlage widerstand mit Metakaolin dem milden S\u00e4ureangriff sp\u00fcrbar besser.' },
    },
    en: {
      intro: ['With a reduced content of soluble hydrated lime, resistance to mild acidic exposure increases.', 'Relevant in industry, agriculture and wastewater facilities.'],
      example: { title: 'Practical example', text: 'Concrete in a biogas plant withstood mild acid attack noticeably better with metakaolin.' },
    },
  },
  'co2-reduction': {
    chart: {
      unit: { de: 'CO\u2082 des Bindemittels bei 15\u00a0% Ersatz \u2013 niedriger ist besser', en: 'Binder CO\u2082 at 15% replacement \u2013 lower is better' },
      bars: [
        { key: 'ref', value: 100, display: '100', highlight: false },
        { key: 'mk', value: 82, display: '~82', highlight: true },
      ],
    },
    de: {
      intro: ['Die Herstellung von Portlandzementklinker ist mit erheblichen CO\u2082-Emissionen verbunden. Der Ersatz eines Teils des Klinkers durch Metakaolin kann den bilanzierten CO\u2082-Fu\u00dfabdruck des Bindemittels senken; die tats\u00e4chliche Wirkung ist system- und bilanzierungsabh\u00e4ngig.', 'Ein m\u00f6glicher Baustein f\u00fcr nachhaltigeres Bauen.'],
      example: { title: 'Praxisbeispiel', text: 'In einem gepr\u00fcften Fertigteilsystem konnte durch rund 15\u00a0% Metakaolin der bilanzierte CO\u2082-Fu\u00dfabdruck der Betone gesenkt werden. Die \u00dcbertragbarkeit ist rezeptur- und bilanzierungsabh\u00e4ngig.' },
    },
    en: {
      intro: ['The production of Portland cement clinker involves substantial CO\u2082 emissions. Replacing part of the clinker with metakaolin can lower the accounted CO\u2082 footprint of the binder; the actual effect depends on the system and the accounting method.', 'A potential building block for more sustainable construction.'],
      example: { title: 'Practical example', text: 'In a tested precast system, around 15% metakaolin reduced the accounted CO\u2082 footprint of the concretes. Transferability depends on the mix design and accounting method.' },
    },
  },
  'setting-time': {
    chart: {
      unit: { de: 'Erstarrungsbeginn in Minuten (illustrativ)', en: 'Initial setting time in minutes (illustrative)' },
      bars: [
        { key: 'ref', value: 180, display: '180 min', highlight: false },
        { key: 'mk', value: 150, display: '~150 min', highlight: true },
      ],
    },
    de: {
      intro: ['Metakaolin beeinflusst das Erstarrungs- und Erh\u00e4rtungsverhalten und l\u00e4sst sich zur Feinabstimmung im Bindemittelsystem einsetzen.', 'In Kombination mit anderen Zusatzmitteln ist eine gezielte Steuerung m\u00f6glich.'],
      example: { title: 'Praxisbeispiel', text: 'In einem Reparaturm\u00f6rtel unterst\u00fctzte Metakaolin eine z\u00fcgige Anfangsfestigkeit bei guter Verarbeitbarkeit.' },
    },
    en: {
      intro: ['Metakaolin influences setting and hardening behaviour and can be used to fine-tune the binder system.', 'Combined with other admixtures, targeted control is possible.'],
      example: { title: 'Practical example', text: 'In a repair mortar, metakaolin supported a rapid early strength while maintaining good workability.' },
    },
  },
};

export const getFeatureDetail = (slug) => featureDetails[slug];
